import { render, staticRenderFns } from "./BasicPackageChanges.vue?vue&type=template&id=9587d6d8&scoped=true&"
import script from "./BasicPackageChanges.vue?vue&type=script&lang=js&"
export * from "./BasicPackageChanges.vue?vue&type=script&lang=js&"
import style0 from "./BasicPackageChanges.vue?vue&type=style&index=0&id=9587d6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9587d6d8",
  null
  
)

export default component.exports